
import { Component, Vue } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
import FullLoading from '@/components/full_loading/index.vue'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import RowItem from '@/components/detail/row_item/index.vue'

const examineStatus = {
    ing: {
        value: 0, name: '审核中'
    },
    pass: {
        value: 1, name: '审核通过'
    },
    fail: {
        value: 2, name: '审核不通过'
    }
}

@Component({
    name: 'pr-cert-detail',
    components: {
        FullLoading,
        CreateDetailLayout,
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private prId = ''
    private pr: any = { company: {}, user: {}, status: 0 }
    private isLoading = true
    private isUpdateLoading = false
    private srcList: any = []
    private examineStatus = examineStatus

    get matchStatus() {
        const status = {
            [examineStatus.ing.value]: examineStatus.ing.name,
            [examineStatus.pass.value]: examineStatus.pass.name,
            [examineStatus.fail.value]: examineStatus.fail.name
        }
        // @ts-ignore
        return status[this.pr.status]
    }

    private created() {
        this.prId = this.$route.params.id
    }

    private async mounted() {

        this.$title('loading | pr入驻详情 - 庖丁')
        this.isLoading = true
        try {
            await this.getPrDetail()
        } catch (e) {
            console.error('加载机构认证详情失败:', e)
        } finally {
            this.isLoading = false
        }
    }

    /** 获取机构详情 */
    private async getPrDetail() {
        try {
            const params = {
                id: +this.prId
            }
            const result = await EnterpriseService.getPrCertDetail(params)
            console.log('PR认证详情接口返回:', result)
            if (result && result.status === 200 && result.data) {
                const data = result.data
                this.pr = {
                    ...data,
                    company: data.company || {},
                    user: data.user || {},
                    status: data.status !== undefined ? data.status : 0,
                    contact_details: data.contactDetails || data.contact_details || '',
                    created_at: data.createdAt || data.created_at || '',
                    updated_at: data.updatedAt || data.updated_at || '',
                    work_cert_img: data.workCertImg || data.work_cert_img || '',
                    id_card_img: data.idCardImg || data.id_card_img || '',
                    user_id: data.userId || data.user_id || ''
                }
                const { id_card_img, work_cert_img, idCardImg, workCertImg } = data
                this.srcList = [id_card_img || idCardImg, work_cert_img || workCertImg].filter(Boolean)
            } else {
                console.error('接口返回数据不符合预期:', result)
            }
        } catch (e) {
            console.error('获取PR认证详情失败:', e)            
        }
    }

    private matchButtonType(status: number) {
        return this.pr.status === status ? 'primary' : 'default'
    }

    private async changeStatus(status: number) {
        this.showLoading()
        const params = {
            id: +this.prId,
            status
        }
        const result = await EnterpriseService.updatePrCertStatus(params)
        this.hideLoading()
        if (result.status === 200) {
            this.pr.status = status
            return this.$message({
                showClose: true,
                type: 'success',
                message: '修改状态成功'
            })
        }
        this.$message({
            showClose: true,
            type: 'error',
            message: result.message || '发生错误, 修改状态失败'
        })
    }

    private showLoading() {
        this.isUpdateLoading = true
    }

    private hideLoading() {
        this.isUpdateLoading = false
    }
}
